import { useAddLargeExcel } from '@/components/hooks/customs/addLargeTable/useAddLargeExcel';
import React from 'react';
import { Link } from 'react-router-dom';
import * as S from './AddLargeTable.index.styles';
import { DefaultRowData } from '@/apis/api/addressApis';
import Logo from '@/components/Atom/Logo';

interface IAddLargeExcel {
  handleAddRow: () => void;
  rows: DefaultRowData[];
  setRows: React.Dispatch<React.SetStateAction<DefaultRowData[]>>;
}

const AddLargeExcel = (props: IAddLargeExcel) => {
  const excelHooks = useAddLargeExcel({ handleAddRow: props.handleAddRow, rows: props.rows, setRows: props.setRows });

  return (
    <S.AddLargeTableLeftZone>
      {/* 로고 */}
      <S.LogoWrap>
        <Logo eType="Home" sType="B" />
      </S.LogoWrap>
      <S.LeftFileDropWrap>
        <label htmlFor="fileUpload" ref={excelHooks.dragRef}>
          <img src="/img/largetable/file.png" alt="fileImage" />
          <span>
            EXCEL 파일 첨부
            <br />
            클릭 또는 파일을 드래그하여
            <br />
            파일첨부가 가능합니다.
            <span className={'alert'}>
              <br />
              <br />※ 엑셀 파일 &quot;휴대폰 번호&quot; 셀의 서식을
              <br /> &quot;텍스트&quot; 로 지정 후 작성해주세요.
            </span>
          </span>
        </label>
        <input
          type="file"
          id={'fileUpload'}
          onClick={() => {}}
          ref={excelHooks.fileInputRef}
          style={{ display: 'none' }}
          multiple={false}
          onChange={excelHooks.onChangeFiles}
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
        />
      </S.LeftFileDropWrap>
      <S.DownloadBtn onClick={() => excelHooks.handleClick()}>엑셀 양식 다운로드</S.DownloadBtn>
    </S.AddLargeTableLeftZone>
  );
};
export default AddLargeExcel;
